module.exports = __webpack_public_path__ + "static/media/Logotipo.3a37fbec.png";